/**
 * The page is imported from **its own module**, not from the `@pages` barrel: the barrel re-exports
 * every page, so one import would pull all of them into the chunk the entry preloads.
 */
import { createFileRoute } from '@tanstack/react-router';

import { DraftsPage } from '@pages/drafts/page.js';
import { DocumentDraftModel } from '@units/document-draft';
import { IamService } from '@units/iam';

/**
 * `/drafts` — wiring only (`rules/frontend-fsd.mdc` rule 10).
 *
 * **Свой раздел, а не вкладка реестра документов** (контракт «проекта документа», §5): проект и
 * документ в обращении различаются юридическим весом, а не оформлением, и один перечень на двоих
 * приглашает сослаться на проект как на действующий документ.
 *
 * Право — `document:read`: раздел показывает то, что собрано из документов, и закрыт тем же ключом,
 * что и они. Выгрузка файлом стоит за **отдельным** правом с меткой `dangerous` (контракт §4) и
 * проверяется сервером; гейта раздела она не касается.
 *
 * `whenDenied: 'forbidden'` — как у реестра документов и по той же причине: раздел стоит в
 * навигации каждого, кто держит право, поэтому его существование не секрет внутри организации и
 * отказ может назвать, чего не хватает. Секрет — сами проекты, и они отвечают `404`.
 *
 * Схема отбора — состояние экрана, провалидированное здесь, чтобы правленный руками адрес не доехал
 * до компонента: страница словом и неизвестный порядок падают в умолчание **внутри схемы**, а не
 * заменяют экран границей ошибки.
 */
export const Route = createFileRoute('/_authenticated/drafts/')({
  beforeLoad: IamService.IamGuards.requirePermission({
    permission: 'document:read',
    whenDenied: 'forbidden',
  }),
  validateSearch: DocumentDraftModel.draftRegistrySearchSchema,
  component: DraftsPage,
  staticData: { crumbKey: 'nav.drafts' },
});
